import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LightspeedAuthService {
  constructor(private readonly _http: HttpClient) {}

  public saveCode(code: string): Observable<any> {
    return this._http.post<string>(
      `${environment.baseUrl}Dashboard/AddTokenJob/${code}`,
      null
    );
  }
}
